import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { currencyFilter } from '@/utils/string'
import { getAmenityIconByKey } from '@/utils/amenity'
import { SpecialRequirement } from "@/models/dto/SalesBotRequirements"
import { SpecialRequirementsTypeKey } from '@/utils/enum';
import { getRequirementIconByKey } from '@/utils/icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotSpecialRequirementOptionCard',
  props: {
    specialRequirement: null,
    selected: { type: Boolean }
  },
  emits: ['toggle'],
  setup(__props: any, { emit }) {

const props = __props as {
  specialRequirement: SpecialRequirement,
  selected: boolean,
};



const toggle = () => emit('toggle')

return { __sfc: true,props, emit, toggle, getRequirementIconByKey }
}

})